import * as ActionTypes from '../constants/actionTypes'
import { sellerChatsGet } from '../api/seller'
import { generateChatbotUrl } from '../shared/utils'

export const fetchItems = (params = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.SELLERCHATLIST_FETCHITEMS_LOAD })

  let result
  try {
    result = await sellerChatsGet(params)
    dispatch({
      type: ActionTypes.SELLERCHATLIST_FETCHITEMS_SUCCEED,
      items: result
        .map(messenger => ({
          idnum: messenger.id,
          n_type: messenger.messengerType,
          s_url: generateChatbotUrl(messenger.messengerType, messenger.messengerId) || messenger.url,
        })),
      total: 3,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.SELLERCHATLIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения списка чатов для торговой сети',
    })
  }
  return result
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.SELLERCHATLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.SELLERCHATLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.SELLERCHATLIST_SEARCHTABLE_EDIT,
    search,
  })
}



// WEBPACK FOOTER //
// src/actions/sellerChatList.js